'use client'

import { useMemo } from 'react'
import { Button } from '@acko/button'
import { Typography } from '@acko/typography'
import { resolveAbhaHeroStepData } from '@components/NewProduct/AbhaHeroWidget/steps/abhaHeroStepData'

export type AbhaHeroErrorStepContent = {
  title: string
  ctaText: string
}

export type AbhaHeroErrorStepProps = {
  data?: Record<string, unknown>
  isMobile: boolean
  message: string
  onClose: () => void
}

const ERROR_STEP_DEFAULTS: AbhaHeroErrorStepContent = {
  title: 'Something went wrong',
  ctaText: 'Close',
}

export const AbhaHeroErrorStep = ({ data, isMobile, message, onClose }: AbhaHeroErrorStepProps) => {
  const stepData = useMemo(
    () => resolveAbhaHeroStepData(data, isMobile, ERROR_STEP_DEFAULTS),
    [data, isMobile],
  )

  return (
    <div className="abha-hero-modal__content">
      <div className="abha-hero-modal__intro">
        <Typography variant="heading-lg" as="h2" color="primary" className="abha-hero-modal__intro-title">
          {stepData.title}
        </Typography>
        <Typography scale="sm" emphasis="normal" color="secondary" className="abha-hero-modal__intro-description">
          {message}
        </Typography>
      </div>

      <div className="abha-hero-modal__footer">
        <div className="abha-hero-modal__footer-action">
          <Button type="button" variant="primary" size="lg" fullWidth onClick={onClose}>
            {stepData.ctaText}
          </Button>
        </div>
      </div>
    </div>
  )
}
